import { Coordinate } from '../model/coordinate';
import { LineStyle, LineWidth, setLineStyle, drawSimpleLine } from './draw-line';
import { IPaneRenderer } from './ipane-renderer';
import { ExtendedType } from '../model/simple-line-options';

export interface SimpleLineRendererData {
	color: string;
	height: number;
	lineStyle: LineStyle;
	lineWidth: LineWidth;
	x1: Coordinate;
	y1: Coordinate;
	x2: Coordinate;
	y2: Coordinate;
	extended: ExtendedType;
	visible?: boolean;
	width: number;
}

export class SimpleLineRenderer implements IPaneRenderer {
	private _data: SimpleLineRendererData | null = null;

	public setData(data: SimpleLineRendererData): void {
		this._data = data;
	}

	public isSpecial(): boolean {
		return false;
	}

	public draw(ctx: CanvasRenderingContext2D, paneID: number, pixelRatio: number, isHovered: boolean, hitTestData?: unknown): void {
		if (this._data === null) {
			return;
		}

		if (this._data.visible === false) {
			return;
		}

		const x1 = /*Math.round(*/this._data.x1 * pixelRatio;//);
		const y1 = /*Math.round(*/this._data.y1 * pixelRatio;//);
		const x2 = /*Math.round(*/this._data.x2 * pixelRatio;//);
		const y2 = /*Math.round(*/this._data.y2 * pixelRatio;//);

		const maxY = Math.ceil(this._data.height * pixelRatio);

		//if ((y1===y2) && (y1<0 || y1>maxY)) return;
		
		///const width = Math.ceil(this._data.width * pixelRatio);
		ctx.lineCap = 'butt';
		ctx.strokeStyle = this._data.color;
		ctx.lineWidth = Math.floor(this._data.lineWidth * pixelRatio);
		setLineStyle(ctx, this._data.lineStyle);

		if (this._data.extended==ExtendedType.NoExtended)
		{
			drawSimpleLine(ctx,x1,y1,x2,y2);
			return;
		}

		let dx = x2-x1;
		let dy = y2-y1;
		let dxu = dx;
		let dyu = dy;
		
		if (dxu<0.0) {
			dxu*=-1.0;
			dyu*=-1.0;
		}
		let len = Math.sqrt(dxu*dxu + dyu*dyu);
		let s = 100.0;//*len;

		if (this._data.extended==ExtendedType.ExtendedInfinity)
		{
			drawSimpleLine(ctx,x1-s*dxu,y1-s*dyu,
				               x1+s*dxu,y1+s*dyu);
		}
		else
		if (this._data.extended==ExtendedType.ExtendedRight)
		{			
			if (dx>=0.0) drawSimpleLine(ctx,x1      ,y1,
				                            x1+s*dxu,y1+s*dyu);
					else drawSimpleLine(ctx,x2      ,y2,
						                    x2+s*dxu,y2+s*dyu);
		}
		else
		if (this._data.extended==ExtendedType.ExtendedLeft)
		{			
			if (dx>=0.0) drawSimpleLine(ctx,x2      ,y2,
				                            x2-s*dxu,y2-s*dyu);
					else drawSimpleLine(ctx,x1      ,y1,
						                    x1-s*dxu,y1-s*dyu);
		}

	}

}
